import AttributeEditorTable, {
  AttributeConfiguration,
} from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/Panels/AttributeEditorTable';
import { DeviceAttribute, ModuleDevice } from 'dashboard/modules/Device';

const ATTRIBUTES: AttributeConfiguration<DeviceAttribute>[] = [
  {
    label: 'Browser',
    key: 'browser',
    display: true,
  },
  {
    label: 'Broswer fingerprint',
    key: 'browser-fingerprint',
    display: true,
  },
  {
    label: 'Device vendor ID',
    key: 'device-vendor-id',
    display: true,
  },
  {
    label: 'Network country name',
    key: 'country-name',
    display: true,
  },
  {
    label: 'Network IP address',
    key: 'ip-address',
    display: true,
  },
  {
    label: 'Datacenter connection',
    key: 'is-datacenter',
    display: true,
  },
  {
    label: 'Service provider',
    key: 'is-isp',
    display: true,
  },
  {
    label: 'Proxy connection',
    key: 'is-proxy',
    display: true,
  },
  {
    label: 'Tor connection',
    key: 'is-tor',
    display: true,
  },
  {
    label: 'VPN',
    key: 'is-vpn',
    display: true,
  },
  {
    label: 'Latitude',
    key: 'latitude',
    display: true,
  },
  {
    label: 'Longitude',
    key: 'longitude',
    display: true,
  },
  {
    label: 'Device OS',
    key: 'os',
    display: true,
  },
  {
    label: 'Network region name',
    key: 'region-name',
    display: true,
  },
  {
    label: 'Threat rating',
    key: 'threat-level',
    display: true,
  },
  {
    label: 'Device type',
    key: 'type',
    display: true,
  },
  {
    label: 'Device handoff method',
    key: 'device-handoff-method',
    display: true,
  },
  {
    label: 'IP Connection Type',
    key: 'ip-connection-type',
    display: true,
  },
];

export interface DevicePanelProps {
  module: ModuleDevice;
  updateModule: (module: ModuleDevice) => void;
}

const DevicePanel = ({ module, updateModule }: DevicePanelProps) => {
  const updateAttributes = (attributes: DeviceAttribute[]) => {
    updateModule({ ...module, attributes });
  };

  return (
    <AttributeEditorTable<DeviceAttribute>
      allAttributes={ATTRIBUTES}
      moduleAttributes={module.attributes}
      updateAttributes={updateAttributes}
    />
  );
};

export default DevicePanel;
